export default __webpack_public_path__ + "static/media/callCenter.ed440ecd.svg";